module.exports = require("core-js/library/fn/is-iterable");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/is-iterable.js
// module id = 257
// module chunks = 92